import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const COULEUR = '#1C2833';
const ROUGE = '#C0392B';
const UNITES = ['Sac', 'Bidon', 'Baril', 'Boîte', 'Litre', 'Kg', 'Unité'];

export default function GestionProduits({ onClose }) {
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recherche, setRecherche] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [produitAModifier, setProduitAModifier] = useState(null);
  const [produitASupprimer, setProduitASupprimer] = useState(null);
  const [saving, setSaving] = useState(false);

  // Formulaire nouveau produit
  const [nom, setNom] = useState('');
  const [description, setDescription] = useState('');
  const [unite, setUnite] = useState('Sac');
  const [prix, setPrix] = useState('');
  const [photoUrl, setPhotoUrl] = useState('');

  // Formulaire modification
  const [modNom, setModNom] = useState('');
  const [modDescription, setModDescription] = useState('');
  const [modUnite, setModUnite] = useState('Sac');
  const [modPrix, setModPrix] = useState('');
  const [modPhotoUrl, setModPhotoUrl] = useState('');

  useEffect(() => { charger(); }, []);

  const charger = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, 'produits'));
      setProduits(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.log(e); }
    setLoading(false);
  };

  const ouvrirModifier = (p) => {
    setProduitAModifier(p);
    setModNom(p.nom || '');
    setModDescription(p.description || '');
    setModUnite(p.unite || 'Sac');
    setModPrix(p.prix != null ? String(p.prix) : '');
    setModPhotoUrl(p.photoUrl || '');
  };

  const ajouterProduit = async () => {
    if (!nom.trim()) return;
    setSaving(true);
    try {
      await addDoc(collection(db, 'produits'), { nom, description, unite, prix: prix ? parseFloat(prix) : null, photoUrl, createdAt: serverTimestamp() });
      setShowAdd(false);
      setNom(''); setDescription(''); setUnite('Sac'); setPrix(''); setPhotoUrl('');
      await charger();
    } catch (e) { alert('Erreur: ' + e.message); }
    setSaving(false);
  };

  const modifierProduit = async () => {
    if (!modNom.trim() || !produitAModifier) return;
    setSaving(true);
    try {
      await updateDoc(doc(db, 'produits', produitAModifier.id), {
        nom: modNom, description: modDescription, unite: modUnite,
        prix: modPrix ? parseFloat(modPrix) : null, photoUrl: modPhotoUrl
      });
      setProduitAModifier(null);
      await charger();
    } catch (e) { alert('Erreur: ' + e.message); }
    setSaving(false);
  };

  const supprimerProduit = async () => {
    if (!produitASupprimer) return;
    setSaving(true);
    try {
      await deleteDoc(doc(db, 'produits', produitASupprimer.id));
      setProduitASupprimer(null);
      await charger();
    } catch (e) { alert('Erreur: ' + e.message); }
    setSaving(false);
  };

  const produitsFiltres = produits.filter(p =>
    !recherche || p.nom?.toLowerCase().includes(recherche.toLowerCase())
  );

  return (
    <div style={styles.app}>
      <div style={styles.topbar}>
        <button onClick={onClose} style={styles.backBtn}>←</button>
        <div style={{ flex: 1 }}>
          <div style={styles.topbarTitle}>🛍️ Gestion Produits</div>
          <div style={styles.topbarSub}>{produits.length} produit(s)</div>
        </div>
        <button style={styles.addBtn} onClick={() => setShowAdd(true)}>+ Produit</button>
      </div>

      <div style={styles.searchWrap}>
        <input style={styles.searchInput} placeholder="🔍 Rechercher un produit..."
          value={recherche} onChange={e => setRecherche(e.target.value)} />
      </div>

      <div style={styles.listWrap}>
        {loading && <div style={styles.empty}>Chargement...</div>}
        {!loading && produitsFiltres.length === 0 && (
          <div style={styles.empty}>
            <div style={{ fontSize: 32 }}>🛍️</div>
            <div>Aucun produit trouvé</div>
            <button style={styles.addEmptyBtn} onClick={() => setShowAdd(true)}>+ Ajouter un produit</button>
          </div>
        )}
        {produitsFiltres.map(p => (
          <div key={p.id} style={styles.produitCard}>
            <div style={styles.produitRow}>
              {p.photoUrl ? (
                <img src={p.photoUrl} alt={p.nom} style={styles.produitPhoto}
                  onError={e => { e.target.style.display = 'none'; }} />
              ) : (
                <div style={styles.produitPhotoPlaceholder}>🎨</div>
              )}
              <div style={{ flex: 1 }}>
                <div style={styles.produitNom}>{p.nom}</div>
                {p.description && <div style={styles.produitDesc}>{p.description}</div>}
                <div style={styles.produitUnite}>Unité : {p.unite || 'Sac'}{p.prix != null ? ` · ${Number(p.prix).toLocaleString('fr-FR')} DA` : ''}</div>
              </div>
            </div>
            <div style={styles.actionsRow}>
              <button style={{ ...styles.actionBtn, color: '#185FA5' }} onClick={() => ouvrirModifier(p)}>✏️ Modifier</button>
              <button style={{ ...styles.actionBtn, color: ROUGE }} onClick={() => setProduitASupprimer(p)}>🗑 Supprimer</button>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL NOUVEAU PRODUIT */}
      {showAdd && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modal, maxHeight: '88vh', overflowY: 'auto' }}>
            <div style={styles.modalTitle}>➕ Nouveau produit</div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Nom du produit *</div>
              <input style={styles.formInput} placeholder="Ex: Peinture blanche 25L"
                value={nom} onChange={e => setNom(e.target.value)} />
            </div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Description (optionnel)</div>
              <input style={styles.formInput} placeholder="Ex: Peinture acrylique intérieure"
                value={description} onChange={e => setDescription(e.target.value)} />
            </div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Unité</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {UNITES.map(u => (
                  <button key={u} style={{ ...styles.chipBtn, ...(unite === u ? styles.chipBtnActive : {}) }}
                    onClick={() => setUnite(u)}>{u}</button>
                ))}
              </div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Prix unitaire en DA (optionnel)</div>
              <input style={styles.formInput} placeholder="Ex: 4500" type="number" min="0"
                value={prix} onChange={e => setPrix(e.target.value)} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={styles.formLabel}>Lien photo (optionnel)</div>
              <input style={styles.formInput} placeholder="https://... (URL de la photo)"
                value={photoUrl} onChange={e => setPhotoUrl(e.target.value)} />
              {photoUrl ? (
                <img src={photoUrl} alt="aperçu" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8, marginTop: 8 }}
                  onError={e => e.target.style.display = 'none'} />
              ) : null}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={styles.btnCancel} onClick={() => setShowAdd(false)}>Annuler</button>
              <button style={{ ...styles.btnConfirm, opacity: nom ? 1 : 0.4 }}
                onClick={ajouterProduit} disabled={saving || !nom}>
                {saving ? 'Enregistrement...' : '✅ Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL MODIFIER PRODUIT */}
      {produitAModifier && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modal, maxHeight: '88vh', overflowY: 'auto' }}>
            <div style={styles.modalTitle}>✏️ Modifier produit</div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Nom du produit *</div>
              <input style={styles.formInput} placeholder="Nom du produit"
                value={modNom} onChange={e => setModNom(e.target.value)} />
            </div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Description (optionnel)</div>
              <input style={styles.formInput} placeholder="Description"
                value={modDescription} onChange={e => setModDescription(e.target.value)} />
            </div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Unité</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {UNITES.map(u => (
                  <button key={u} style={{ ...styles.chipBtn, ...(modUnite === u ? styles.chipBtnActive : {}) }}
                    onClick={() => setModUnite(u)}>{u}</button>
                ))}
              </div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <div style={styles.formLabel}>Prix unitaire en DA (optionnel)</div>
              <input style={styles.formInput} placeholder="Ex: 4500" type="number" min="0"
                value={modPrix} onChange={e => setModPrix(e.target.value)} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={styles.formLabel}>Lien photo (optionnel)</div>
              <input style={styles.formInput} placeholder="https://..."
                value={modPhotoUrl} onChange={e => setModPhotoUrl(e.target.value)} />
              {modPhotoUrl ? (
                <img src={modPhotoUrl} alt="aperçu" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8, marginTop: 8 }}
                  onError={e => e.target.style.display = 'none'} />
              ) : null}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={styles.btnCancel} onClick={() => setProduitAModifier(null)}>Annuler</button>
              <button style={{ ...styles.btnConfirm, opacity: modNom ? 1 : 0.4 }}
                onClick={modifierProduit} disabled={saving || !modNom}>
                {saving ? 'Enregistrement...' : '✅ Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL SUPPRIMER */}
      {produitASupprimer && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div style={styles.modalTitle}>🗑 Supprimer produit</div>
            <div style={{ fontSize: 14, color: '#444', marginBottom: 8 }}>
              Supprimer <strong>{produitASupprimer.nom}</strong> ?
            </div>
            <div style={{ fontSize: 12, color: ROUGE, background: '#FCEBEB', padding: '8px 12px', borderRadius: 8, marginBottom: 16 }}>
              ⚠️ Action irréversible
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={styles.btnCancel} onClick={() => setProduitASupprimer(null)}>Annuler</button>
              <button style={{ ...styles.btnConfirm, background: ROUGE }} onClick={supprimerProduit} disabled={saving}>
                {saving ? 'Suppression...' : '🗑 Confirmer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  app: { maxWidth: 480, margin: '0 auto', minHeight: '100vh', background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'system-ui, sans-serif' },
  topbar: { background: COULEUR, padding: '1rem 1.25rem', color: '#fff', display: 'flex', alignItems: 'center', gap: 10 },
  backBtn: { background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: '#fff', fontSize: 16, cursor: 'pointer', flexShrink: 0 },
  topbarTitle: { fontSize: 15, fontWeight: 600 },
  topbarSub: { fontSize: 11, opacity: 0.7, marginTop: 2 },
  addBtn: { background: ROUGE, border: 'none', borderRadius: 8, color: '#fff', fontSize: 12, fontWeight: 600, padding: '6px 12px', cursor: 'pointer', flexShrink: 0 },
  searchWrap: { padding: '8px 12px', background: '#fff', borderBottom: '1px solid #eee' },
  searchInput: { width: '100%', padding: '9px 12px', border: '1px solid #eee', borderRadius: 8, fontSize: 14, background: '#f9f9f9', fontFamily: 'system-ui', boxSizing: 'border-box' },
  listWrap: { flex: 1, overflowY: 'auto', padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 8 },
  empty: { textAlign: 'center', color: '#888', padding: '3rem 1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 },
  addEmptyBtn: { marginTop: 8, padding: '10px 20px', background: COULEUR, border: 'none', borderRadius: 8, color: '#fff', fontSize: 13, cursor: 'pointer' },
  produitCard: { background: '#fff', borderRadius: 10, padding: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  produitRow: { display: 'flex', gap: 10, alignItems: 'center' },
  produitPhoto: { width: 60, height: 60, borderRadius: 8, objectFit: 'cover', flexShrink: 0 },
  produitPhotoPlaceholder: { width: 60, height: 60, borderRadius: 8, background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, flexShrink: 0 },
  produitNom: { fontSize: 14, fontWeight: 600, color: COULEUR },
  produitDesc: { fontSize: 12, color: '#888', marginTop: 2 },
  produitUnite: { fontSize: 11, color: '#185FA5', marginTop: 4, fontWeight: 500 },
  actionsRow: { display: 'flex', gap: 8, marginTop: 10, paddingTop: 10, borderTop: '1px solid #f5f5f5' },
  actionBtn: { flex: 1, padding: '7px', border: '1px solid #eee', borderRadius: 8, background: '#f9f9f9', color: '#444', fontSize: 12, cursor: 'pointer', textAlign: 'center' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.55)', zIndex: 100, display: 'flex', alignItems: 'flex-end' },
  modal: { background: '#fff', width: '100%', maxWidth: 480, margin: '0 auto', borderRadius: '20px 20px 0 0', padding: '20px 16px 30px' },
  modalTitle: { fontSize: 15, fontWeight: 600, color: COULEUR, marginBottom: 14 },
  formLabel: { fontSize: 12, color: '#666', marginBottom: 4 },
  formInput: { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, fontFamily: 'system-ui', boxSizing: 'border-box' },
  chipBtn: { padding: '6px 12px', border: '1px solid #ddd', borderRadius: 99, background: '#fff', color: '#666', fontSize: 11, cursor: 'pointer' },
  chipBtnActive: { border: `1px solid ${COULEUR}`, background: COULEUR, color: '#fff', fontWeight: 600 },
  btnCancel: { flex: 1, padding: 11, border: '1px solid #ddd', borderRadius: 10, background: '#fff', color: '#666', fontSize: 14, cursor: 'pointer' },
  btnConfirm: { flex: 2, padding: 11, background: COULEUR, border: 'none', borderRadius: 10, color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
};
